export default __webpack_public_path__ + "static/media/lp-token.5565a560.svg";